import { RootState } from '../..'

export const selectMenuItems = (state: RootState) => state.main.portal.navigation.menuItems
